import Catalog from 'catalog/components/Catalog/Catalog.jsx';
import CatalogProvider from 'catalog/CatalogProvider.jsx';

const root = Catalog;
const provider = CatalogProvider;
const main = provider;

export const widgets = {
    Catalog: {
        components: {
            root,
            provider,
            main,
        },
    },
};

export default {
    root,
    provider,
    Catalog: main,
};
